import { render, staticRenderFns } from "./svg-logo.vue?vue&type=template&id=0afc8b51&scoped=true"
import script from "./svg-logo.vue?vue&type=script&lang=ts"
export * from "./svg-logo.vue?vue&type=script&lang=ts"
import style0 from "./svg-logo.vue?vue&type=style&index=0&id=0afc8b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc8b51",
  null
  
)

export default component.exports